module.exports = __webpack_public_path__ + "static/media/hipster_1_bottom.c2f86a18.svg";